import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ReportMeta, ReportsService } from 'src/app/services/reports.service';
import { CommonService } from '../../services/common.service';
import { Detail, DrilldownFormsService } from '../../services/drilldown-forms.service';

export interface Insight {
  id: number;
  insight: string;
  insightTag: string;
  subTitle?: string;
  type: string;
  value: number;
}

interface RiskCoachOrPdf {
  image: string;
  name: string;
  subTitle: string;
  summary: string;
  summaryTag: string;
}

interface ProfileInsightDetails {
  detail: Detail;
  drivers: Array<any>;
  pdf: RiskCoachOrPdf;
  riskCoach: RiskCoachOrPdf;
}

@Component({
  selector: 'profile-insight-details',
  templateUrl: './profile-insight-details.component.html',
  styleUrls: ['./profile-insight-details.component.scss'],
})
export class ProfileInsightDetailsComponent {
  profileInsightDetails: ProfileInsightDetails;
  driverReportMeta: ReportMeta;

  usesMobileWhileDriving: Array<any>;
  pdfGuide: RiskCoachOrPdf;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Insight,
    public cService: CommonService,
    private dfService: DrilldownFormsService,
    private rptService: ReportsService
  ) {
    this.dfService.getProfileInsightDetailsForkJoined(this.data.id).subscribe({
      next: (responses: Array<any>) => {
        this.driverReportMeta = responses[0];
        this.profileInsightDetails = responses[1];

        console.log('%c PROFILE INSIGHT DETAILS', 'color: salmon', {
          driverReportMeta: this.driverReportMeta,
          profileInsightDetails: this.profileInsightDetails,
        });

        this.usesMobileWhileDriving = [
          {
            text: this.cService.readyTranslations.generic.theseDrivers,
            percentage: this.profileInsightDetails.detail.manager + '%',
            percentageColor: 'black',
          },
        ];

        if (this.profileInsightDetails.detail.company) {
          this.usesMobileWhileDriving.push({
            text: this.cService.readyTranslations.generic.companyAverage,
            percentage: this.profileInsightDetails.detail.company + '%',
            percentageColor: 'black',
          });
        }

        this.dfService.currentInsightDetail = this.profileInsightDetails.detail;
      },
    });
  }

  sendPdfs() {
    const pins = this.profileInsightDetails ? this.profileInsightDetails.drivers.map((driver) => driver.pin) : [];

    if (pins && pins.length) {
      this.dfService.sendFileViaServer(
        this.profileInsightDetails.detail.id,
        pins,
        this.rptService.requestedServerFilters.vehicle
      );
    }
  }
}
